import React from 'react';
import {TextProps} from '@chakra-ui/react';
import {Col, UiText} from '~/components/elements';
import {Program} from '~/types/models/questionnaire';
import {WL_PROGRAMS} from '~/constants';

interface Props {
  program: Program;
  isSelected: boolean;
  onClick: (value: string) => void;
}

/**
 * MedicationCard component represents a card displaying medication information.
 *
 * @component
 * @param {Props} props - The component props.
 * @param {object} props.program - The medication program object.
 * @param {boolean} props.isSelected - Indicates whether the card is selected.
 * @param {function} props.onClick - The click event handler for the card.
 * @param {object} props.rest - The rest of the component props.
 * @returns {JSX.Element} The rendered MedicationCard component.
 */
const MedicationCard = ({program, isSelected, onClick, ...rest}: Props) => {
  const getPrice = (price: number) => {
    if (price.toString().length <= 2) return price;
    return price.toFixed(2);
  };

  const hidePrice = program.hidePrice || false;

  return (
    <Col
      w="90%"
      borderRadius="1.6rem"
      mb={7}
      cursor={'pointer'}
      boxShadow={isSelected ? '0px 0px 0px 5px #CCDF75' : 'none'}
      border="1px solid #000000"
      onClick={() => onClick(program.value)}
      px={4}
      py={4}
    >
      <Col textAlign="left">
        <UiText fontSize="xl" fontWeight="bold" color="#8DAA09" mb={1.5}>
          {program.label}
        </UiText>
        {!hidePrice && (
          <UiText fontSize="15px" fontWeight="bold" color="trueBlack">
            from{' '}
            <span style={{fontSize: '20px'}}>
              {program.pricePrefix}
              {program.price && getPrice(program.price)}
            </span>{' '}
            / {program.priceSuffix}
          </UiText>
        )}
      </Col>
      <img
        src={program.image}
        alt={program.label}
        style={{width: '100%', height: '6rem', maxWidth: 'none', objectFit: 'contain'}}
      />
      <UiText fontSize="sm">{program?.description}</UiText>
    </Col>
  );
};

export default MedicationCard;
